import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      {/* Animated Background Elements */}
      <div className="neon-grid"></div>
      <div className="floating-orbs">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>
        <div className="orb orb-4"></div>
      </div>
      <div className="scan-line"></div>

      {/* Main Content */}
      <div className="home-content">
        {/* Hero Section */}
        <div className="hero-section">
          <div className="logo-wrapper">
            <div className="logo-container">
              <div className="logo-ring"></div>
              <div className="logo-ring ring-2"></div>
              <img src="/echo.png" alt="Jo Jo Nickname Changer Bot Logo" className="bot-logo" />
              <div className="logo-particles">
                <span></span><span></span><span></span><span></span>
              </div>
            </div>
          </div>
          
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="title-word title-1">Jo Jo</span>
              <span className="title-word title-2">Nickname</span>
              <span className="title-word title-3">Changer</span>
            </h1>
            <p className="hero-tagline">
              <span className="tagline-text">Transform your Discord experience</span>
              <span className="tagline-accent">with seamless nickname management</span>
            </p>
            <p className="hero-description">
              A powerful Discord bot that brings order and style to your server's nickname system. 
              Request, approve, and manage nicknames with ease.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="cta-section">
            <a 
              href="https://discord.com/oauth2/authorize?client_id=1054431594905075822&permissions=690349272145&integration_type=0&scope=bot+applications.commands" 
              className="cta-button primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="button-content">
                <svg className="button-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                </svg>
                <span>Add to Discord</span>
              </span>
              <div className="button-shine"></div>
            </a>
            
            <div className="secondary-buttons">
              <Link to="/privacy" className="cta-button secondary">
                <span>Privacy Policy</span>
              </Link>
              <Link to="/terms" className="cta-button secondary">
                <span>Terms of Service</span>
              </Link>
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div className="features-section">
          <div className="section-header">
            <h2 className="section-title">Features</h2>
            <div className="title-underline"></div>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <i className="fas fa-magic feature-icon"></i>
                <div className="icon-glow"></div>
              </div>
              <h3>Easy Requests</h3>
              <p>Simple nickname change requests with approval workflow</p>
              <div className="feature-accent"></div>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <i className="fas fa-shield-alt feature-icon"></i>
                <div className="icon-glow"></div>
              </div>
              <h3>Smart Filtering</h3>
              <p>Advanced word filtering and moderation tools</p>
              <div className="feature-accent"></div>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <i className="fas fa-scroll feature-icon"></i>
                <div className="icon-glow"></div>
              </div>
              <h3>History Tracking</h3>
              <p>Keep track of nickname changes and history</p>
              <div className="feature-accent"></div>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <i className="fas fa-bolt feature-icon"></i>
                <div className="icon-glow"></div>
              </div>
              <h3>Fast & Reliable</h3>
              <p>Lightning-fast responses with high uptime</p>
              <div className="feature-accent"></div>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="stats-section">
          <div className="stat-card">
            <i className="fas fa-chart-line stat-icon"></i>
            <div className="stat-number">100%</div>
            <div className="stat-label">Uptime</div>
          </div>
          <div className="stat-card">
            <i className="fas fa-sync-alt stat-icon"></i>
            <div className="stat-number">24/7</div>
            <div className="stat-label">Support</div>
          </div>
          <div className="stat-card">
            <i className="fas fa-bolt stat-icon"></i>
            <div className="stat-number">&lt;1s</div>
            <div className="stat-label">Response</div>
          </div>
        </div>

        {/* Footer */}
        <div className="home-footer">
          <div className="footer-content">
            <p className="dev-credit">
              Developed by <span className="dev-name">Joynal Bokhsho</span>
            </p>
            <div className="footer-links">
              <Link to="/privacy">Privacy</Link>
              <span className="separator">•</span>
              <Link to="/terms">Terms</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
